import { Card, FlexRow, Grid, IconType, RotatingIcon } from '../../../../../ui-toolkit';
import React from 'react';
import { UUID } from '../../../../../types/shared/UUID';
import { FormikTouched, useFormikContext } from 'formik';
import { IEscrowFileCompleteData } from '../../../../../types/order/escrow/IEscrowFileCompleteData';
import { CreateEditWireDisbursementsContainer } from '../../disbursements/wireDisbursements/CreateEditWireDisbursementsContainer';
import { CreateEditInternalTransfersContainer } from '../../disbursements/internalTransfers/CreateEditInternalTransfersContainer';
import { CreateEditManualCheckDisbursementContainer } from '../../disbursements/manualCheckDisbursementsTable/CreateEditManualCheckDisbursementContainer';
import { CreateEditAchPushesContainer } from '../../disbursements/achPushDisbursements/CreateEditAchPushesContainer';
import { SpaEscrowCDItemsContainer } from '../../cdItems/SpaEscrowCDItemsContainer';
import { SpaEscrowSubmitButton } from './SpaEscrowSubmitButton';
import { useSelectCurrentFeesVersion } from 'selectors/order/selectCurrentOrder';
import { IParty } from '../../../../../ui-toolkit/orders/interfaces/IParty';
import { IPartyPerson } from '../../../../../ui-toolkit/orders/interfaces/IPartyPerson';

interface ICreateEditOutgoingFormCardProps {
  availableAmountDollars: number;
  borrowersSellers: IParty[];
  escrowFileId: string;
  formChangeFetching: boolean;
  onFormSubmit: (formData: IEscrowFileCompleteData, touched: FormikTouched<IEscrowFileCompleteData>) => Promise<void>;
  onTransactionUpdate: () => void;
  orderId: UUID;
}

export const SpaCreateEditOutgoingFormCard: React.FC<ICreateEditOutgoingFormCardProps> = ({
  availableAmountDollars,
  borrowersSellers,
  escrowFileId,
  formChangeFetching,
  onFormSubmit,
  onTransactionUpdate,
  orderId,
}) => {
  const { dirty } = useFormikContext<IEscrowFileCompleteData>();
  const feesVersion = useSelectCurrentFeesVersion();

  return (
    <Card title={'Outgoing'} isCollapsible>
      <Grid>
        {feesVersion === 'v1' && <SpaEscrowCDItemsContainer />}
        <CreateEditWireDisbursementsContainer
          availableAmountDollars={availableAmountDollars}
          dirty={dirty}
          onTransactionUpdate={onTransactionUpdate}
        />
        <CreateEditAchPushesContainer
          orderId={orderId}
          availableAmountDollars={availableAmountDollars}
          dirty={dirty}
          escrowFileId={escrowFileId}
          parties={borrowersSellers as IPartyPerson[]}
          onAcknowledgeSuccess={onTransactionUpdate}
          onTransactionUpdate={onTransactionUpdate}
        />
        <CreateEditManualCheckDisbursementContainer
          dirty={dirty}
          orderId={orderId}
          onTransactionUpdate={onTransactionUpdate}
        />
        <CreateEditInternalTransfersContainer
          dirty={dirty}
          orderId={orderId}
          onTransactionUpdate={onTransactionUpdate}
          availableAmountDollars={availableAmountDollars}
        />
        <FlexRow justifyContent={'end'}>
          {formChangeFetching && <RotatingIcon type={IconType.Loading} />}
          <SpaEscrowSubmitButton onFormSubmit={onFormSubmit} />
        </FlexRow>
      </Grid>
    </Card>
  );
};
